import * as React from "react";
import { LoadIndicator, ILoadIndicatorOptions } from "devextreme-react/load-indicator";

export default function CircularProgressWithLabel(
  props: ILoadIndicatorOptions & { value: number | null, fontSize?: number }
) {
  return (
    <div style={{ position: "relative", display: "inline-flex" }}>
      <LoadIndicator {...props} />
      <div
        style={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: props.fontSize
        }}
      >
        <span>{props.value ? `${Math.round(props.value)}%` : ""}</span>
      </div>
    </div>
  );
}
